import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["link", "sidebar", "submenu", "scrollContainer"]

    initialize() {
        this.handleTurboLoad = this.applyActiveState.bind(this)
    }

    connect() {
        this.applyActiveState()
        document.addEventListener("turbo:load", this.handleTurboLoad)
    }

    disconnect() {
        document.removeEventListener("turbo:load", this.handleTurboLoad)
    }

    applyActiveState() {
        const currentUrl = new URL(window.location.href)
        const currentPath = currentUrl.pathname.replace(/\/$/, "")
        const currentFullUrl = currentUrl.pathname + currentUrl.search

        // Clear previous states
        this.linkTargets.forEach(link => link.classList.remove("active"))

        let bestMatch = null

        // 1. Try Exact Full Match (Path + Query Params)
        bestMatch = this.linkTargets.find(link => {
            const href = link.getAttribute("href")
            return href && (href === currentFullUrl || href === currentPath)
        })

        // 2. Fallback to Exact Path Match
        if (!bestMatch) {
            bestMatch = this.linkTargets.find(link => {
                const linkPath = new URL(link.getAttribute("href"), window.location.origin).pathname.replace(/\/$/, "")
                return linkPath === currentPath
            })
        }

        // 3. Fallback to Prefix Match (only if no exact match found)
        if (!bestMatch) {
            bestMatch = this.linkTargets.find(link => {
                const linkPath = new URL(link.getAttribute("href"), window.location.origin).pathname.replace(/\/$/, "")
                return linkPath.length > 1 && currentPath.startsWith(linkPath + "/")
            })
        }

        if (bestMatch) {
            bestMatch.classList.add("active")

            // Auto-open parent submenu
            const submenu = bestMatch.closest('[data-charity-sidebar-target="submenu"]')
            if (submenu) {
                this._openSubmenu(submenu)
            }
        }

        // Scroll active link into view
        if (bestMatch && this.hasScrollContainerTarget) {
            requestAnimationFrame(() => {
                bestMatch.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                })
            })
        }

    }

    toggleSubmenu(event) {
        const button = event.currentTarget
        const submenu = button.nextElementSibling

        if (submenu.classList.contains("is-open")) {
            this._closeSubmenu(submenu)
        } else {
            this._openSubmenu(submenu)
        }
    }

    _openSubmenu(submenu) {
        submenu.classList.add("is-open")
        const button = submenu.previousElementSibling
        button?.setAttribute("aria-expanded", "true")
        const icon = button?.querySelector('.material-icons-outlined:last-child')
        if (icon) icon.style.transform = 'rotate(180deg)'
    }

    _closeSubmenu(submenu) {
        submenu.classList.remove("is-open")
        const button = submenu.previousElementSibling
        button?.setAttribute("aria-expanded", "false")
        const icon = button?.querySelector('.material-icons-outlined:last-child')
        if (icon) icon.style.transform = 'rotate(0deg)'
    }

    toggleSidebar(event) {
        if (event) event.preventDefault()
        this.sidebarTarget.classList.toggle("hidden")
        this.sidebarTarget.classList.toggle("flex")
    }
}
